import { render, staticRenderFns } from "./EditDisposisi.vue?vue&type=template&id=0b3d1be7&"
import script from "./EditDisposisi.vue?vue&type=script&lang=js&"
export * from "./EditDisposisi.vue?vue&type=script&lang=js&"
import style0 from "./EditDisposisi.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports